import {
  TablePage,
  AddPage,
  EditPage,
  ViewPage,
} from 'src/views/account-setup/ttfbtprparty'
import pathMap from 'src/paths/PathMap_AccountSetup'

class TtfbTprPartyRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.TTFB_TPR_PARTY_LIST_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.TTFB_TPR_PARTY_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.TTFB_TPR_PARTY_EDIT_VIEW,
        component: EditPage
      },
      {
        exact: true,
        path: pathMap.TTFB_TPR_PARTY_DETAILS_VIEW,
        component: ViewPage
      }
    ]
  }
}

export default TtfbTprPartyRoute
